import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import Isvg from 'react-inlinesvg';
import { DomainWrapper, Icon } from './styled';
import ContextModal, { ContextModalWidth } from '../context-modal';
import { getDomainIcon } from '../../containers/link-upf-modal/link-upf-modal-utils';

const QuestionDomain = ({ domainName, modalWidth = ContextModalWidth }) => {
  const [domainNamePosition, setDomainNamePostion] = useState({});
  const domainRef = useRef(null);
  const [showDomainName, setShowDomainName] = useState(false);

  const getDomainNamePos = () => {
    const { height: domainHeight, width: domainWidth } = domainRef.current.getBoundingClientRect();
    const posX = -((modalWidth - domainWidth) / 2);
    const posArrow = posX + (modalWidth / 2);
    const posY = domainHeight;

    setDomainNamePostion({ posX, posY, posArrow });
  };

  return (
    <DomainWrapper
      ref={domainRef}
      onMouseEnter={() => { setShowDomainName(true); }}
      onMouseLeave={() => { setShowDomainName(false); }}
    >
      <Icon>
        <Isvg src={getDomainIcon(domainName)} cacheGetRequests onLoad={getDomainNamePos} />
      </Icon>
      {domainName && <ContextModal
        show={showDomainName}
        positionArrow={domainNamePosition.posArrow}
        positionX={domainNamePosition.posX}
        positionY={domainNamePosition.posY}
        contextTheme="standard"
        name={domainName}
        fixedParent
        modalWidth={modalWidth}
      />}
    </DomainWrapper>

  );
};

QuestionDomain.propTypes = {
  domainName: PropTypes.string,
  modalWidth: PropTypes.number
};

export default QuestionDomain;
